import React, { useState, createContext } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import { TimeProvider } from './provider/time-provider';
import { UserProvider } from './provider/user-provider';
import { LogInScreen, HomeScreen } from './screen'

export const FieldContext = createContext({});

const App = () => {
  const [fieldId, setFieldId] = useState('');
  const [ownerId, setOwnerId] = useState('');

  return (
    <TimeProvider>
      <FieldContext.Provider value={{ fieldId, setFieldId, ownerId, setOwnerId }}>
        <UserProvider>
          <Router>
            <Switch>
              <Route path="/home">
                <HomeScreen />
              </Route>
              <Route path="/">
                <LogInScreen />
              </Route>
            </Switch>
          </Router>
        </UserProvider>
      </FieldContext.Provider>
    </TimeProvider>
  );
}

export default App
